import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./daily-inventory-admin.css";

const DailyInventoryAdmin = () => {
  const [scheduleData, setScheduleData] = useState({
    family: "",
    ingredient: "",
    location: "", // AJOUTÉ
    frequency: "daily",
    startDate: getTodayDate(),
    active: true
  });
  
  const [scheduledItems, setScheduledItems] = useState([]);
  const [filteredIngredients, setFilteredIngredients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [familiesLoading, setFamiliesLoading] = useState(true);
  const [locations, setLocations] = useState([]); // AJOUTÉ
  const [locationsLoading, setLocationsLoading] = useState(false); // AJOUTÉ
  
  // Récupération des familles depuis Redux
  const familiesData = useSelector((state) => state.IngredientReducer?.families || []);

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    // Vérifier si les familles sont déjà chargées dans Redux
    if (familiesData.length > 0) {
      console.log("Familles chargées depuis Redux:", familiesData.length);
      setFamiliesLoading(false);
    } else {
      // Si pas de familles dans Redux, on les charge
      loadFamiliesData();
    }
    
    // Charger les localisations
    fetchLocations(); // AJOUTÉ
  }, [familiesData]);

  useEffect(() => {
    if (scheduleData.family && familiesData.length > 0) {
      updateIngredientsList();
    }
  }, [scheduleData.family, scheduleData.location, familiesData, scheduledItems]); // AJOUTÉ scheduleData.location

  // Fonction pour charger les familles si Redux est vide
  const loadFamiliesData = async () => {
    try {
      setFamiliesLoading(true);
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      
      console.log("Chargement des familles depuis l'API...");
      const response = await axios.get("/api/Ingredient/families", {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log("Réponse API familles:", response.data);
      
    } catch (error) {
      console.error("Erreur chargement familles:", error);
      showMessage("error", "Erreur lors du chargement des familles");
    } finally {
      setFamiliesLoading(false);
    }
  };

  // Fonction pour charger les localisations
  const fetchLocations = async () => {
    try {
      setLocationsLoading(true);
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const response = await axios.get("/api/Locationspin/getAllLocations", {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      let locationsData = [];
      
      if (response.data) {
        if (Array.isArray(response.data)) {
          locationsData = response.data;
        } else if (response.data.locations && Array.isArray(response.data.locations)) {
          locationsData = response.data.locations;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          locationsData = response.data.data;
        }
      }
      
      // Filtrer les localisations valides
      const validLocations = locationsData.filter(loc => 
        loc && loc._id && loc.name
      );
      
      setLocations(validLocations);
      console.log("Localisations chargées:", validLocations.length);
      
    } catch (error) {
      console.error("Erreur chargement localisations:", error);
      showMessage("error", "Erreur lors du chargement des localisations");
    } finally {
      setLocationsLoading(false);
    }
  };

  const fetchScheduledItems = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      
      // Essayer les deux URLs possibles
      let response;
      try {
        response = await axios.get("/api/daily-inventory/schedule/all", {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      } catch (firstError) {
        console.log("Première URL échouée, essai alternative...");
        response = await axios.get("/api/daily-inventory/schedule", {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      }
      
      if (response.data && response.data.success) {
        setScheduledItems(response.data.schedule || []);
        console.log("Planning chargé:", response.data.schedule?.length || 0, "éléments");
      }
    } catch (error) {
      console.error("Erreur chargement planning:", error);
      // Pas d'erreur visible pour l'utilisateur ici, juste log
    } finally {
      setLoading(false);
    }
  };

  // Fonction principale pour mettre à jour la liste des ingrédients
  const updateIngredientsList = () => {
  console.log("Mise à jour liste ingrédients...");
  console.log("Famille sélectionnée:", scheduleData.family);
  console.log("Localisation sélectionnée:", scheduleData.location);
  
  if (!scheduleData.family) {
    console.log("Aucune famille sélectionnée");
    setFilteredIngredients([]);
    return;
  }

  const selectedFamily = familiesData.find(f => f._id === scheduleData.family);
  
  if (!selectedFamily) {
    console.log("Famille non trouvée dans les données");
    setFilteredIngredients([]);
    return;
  }

  console.log("Famille trouvée:", selectedFamily.name);
  console.log("Ingrédients dans la famille:", selectedFamily.ingredients);

  // PRÉPARER LA LISTE D'INGRÉDIENTS - ADAPTÉE À VOTRE STRUCTURE
  let ingredientsList = [];

  if (selectedFamily.ingredients && Array.isArray(selectedFamily.ingredients)) {
    ingredientsList = selectedFamily.ingredients
      .filter(ing => ing && ing._id && ing.name)
      .map(ingredient => ({
        id: ingredient._id, // C'est l'ID de l'ingrédient imbriqué
        name: ingredient.name,
        unit: 'unité', // Valeur par défaut puisque vous n'avez pas d'unité dans Family
        familyId: selectedFamily._id,
        familyName: selectedFamily.name
      }));
  }

  console.log("Liste d'ingrédients préparée:", ingredientsList.length, "éléments");

  // Marquer les ingrédients déjà programmés
  const finalList = ingredientsList.map(ingredient => {
    const isScheduled = scheduleData.location ? 
      scheduledItems.some(item => 
        item.ingredient && item.ingredient.toString() === ingredient.id.toString() && 
        item.location === scheduleData.location
      ) : 
      scheduledItems.some(item => item.ingredient && item.ingredient.toString() === ingredient.id.toString());

    return {
      id: ingredient.id,
      name: ingredient.name,
      unit: ingredient.unit,
      familyId: ingredient.familyId,
      familyName: ingredient.familyName,
      isScheduled: isScheduled,
      frequency: isScheduled ? scheduledItems.find(item => 
        scheduleData.location ? 
          (item.ingredient && item.ingredient.toString() === ingredient.id.toString() && item.location === scheduleData.location) :
          (item.ingredient && item.ingredient.toString() === ingredient.id.toString())
      )?.frequency : 'daily'
    };
  }).sort((a, b) => a.name.localeCompare(b.name));

  console.log("Liste finale d'ingrédients:", finalList.length, "éléments");
  setFilteredIngredients(finalList);
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setScheduleData(prev => ({
      ...prev,
      [name]: value,
      // Si on change la localisation ou la famille, on réinitialise l'ingrédient
      ...((name === 'location' || name === 'family') && { ingredient: "" })
    }));
  };

 const addToSchedule = async () => {
  if (!scheduleData.family || !scheduleData.ingredient) {
    showMessage("error", "Veuillez sélectionner une famille et un ingrédient");
    return;
  }

  const selectedIngredient = filteredIngredients.find(ing => ing.id === scheduleData.ingredient);
  if (!selectedIngredient) {
    showMessage("error", "Ingrédient non trouvé");
    return;
  }

  // VALIDATION RENFORCÉE
  if (!selectedIngredient.id) {
    console.error("ID d'ingrédient invalide:", selectedIngredient);
    showMessage("error", "ID d'ingrédient invalide");
    return;
  }

  // Vérifier si déjà programmé
  const alreadyScheduled = scheduleData.location ? 
    scheduledItems.some(item => 
      item.ingredient && item.ingredient.toString() === scheduleData.ingredient &&
      item.location === scheduleData.location
    ) :
    scheduledItems.some(item => item.ingredient && item.ingredient.toString() === scheduleData.ingredient);

  if (alreadyScheduled) {
    const locationName = scheduleData.location ? 
      locations.find(loc => loc._id === scheduleData.location)?.name || 'cette localisation' :
      'le planning';
    showMessage("error", `Cet ingrédient est déjà programmé pour ${locationName}`);
    return;
  }

  // CRÉER L'ITEM DU PLANNING
  const newScheduleItem = {
    ingredient: scheduleData.ingredient, // ID de l'ingrédient
    ingredientName: selectedIngredient.name,
    family: scheduleData.family, // ID de la famille
    familyName: selectedIngredient.familyName,
    location: scheduleData.location || null,
    locationName: scheduleData.location ? 
      locations.find(loc => loc._id === scheduleData.location)?.name || 'Inconnue' : 
      'Non spécifiée',
    frequency: scheduleData.frequency,
    startDate: scheduleData.startDate,
    active: scheduleData.active,
    unit: selectedIngredient.unit || 'unité',
    addedAt: new Date().toISOString()
  };

  console.log("Ajout au planning:", newScheduleItem);
  setScheduledItems(prev => [...prev, newScheduleItem]);
  
  // Réinitialiser
  setScheduleData(prev => ({
    ...prev,
    ingredient: "",
    frequency: "daily"
  }));

  showMessage("success", `Ingrédient "${selectedIngredient.name}" ajouté au planning`);
};
  const removeFromSchedule = (ingredientId, locationId = null) => {
    setScheduledItems(prev => prev.filter(item => 
      !(item.ingredient === ingredientId && 
        (locationId ? item.location === locationId : true))
    ));
    showMessage("info", "Ingrédient retiré du planning");
  };

  const updateScheduleItem = (ingredientId, locationId = null, updates) => {
    setScheduledItems(prev => 
      prev.map(item => 
        item.ingredient === ingredientId && 
        (locationId ? item.location === locationId : true)
          ? { ...item, ...updates }
          : item
      )
    );
  };

 const saveSchedule = async () => {
  if (scheduledItems.length === 0) {
    showMessage("error", "Aucun ingrédient programmé");
    return;
  }

  setSaving(true);
  
  try {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    
    // VALIDER QUE CHAQUE ITEM A UN INGRÉDIENT VALIDE
    const invalidItems = scheduledItems.filter(item => !item.ingredient);
    if (invalidItems.length > 0) {
      showMessage("error", `${invalidItems.length} ingrédients n'ont pas d'ID valide`);
      setSaving(false);
      return;
    }

    const scheduleDataToSave = {
      schedule: scheduledItems.map(item => ({
        ingredient: item.ingredient, // S'assurer que ce n'est pas null
        family: item.family,
        location: item.location || null,
        frequency: item.frequency,
        startDate: item.startDate,
        active: item.active !== false,
        unit: item.unit || 'unité'
      }))
    };

    console.log("Envoi planning VALIDÉ:", scheduleDataToSave);

    const response = await axios.post("/api/daily-inventory/schedule/save", scheduleDataToSave, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.data && response.data.success) {
      showMessage("success", "Planning enregistré avec succès !");
      // Recharger le planning depuis le serveur
      fetchScheduledItems();
    } else {
      showMessage("error", response.data?.message || "Erreur lors de l'enregistrement");
    }
  } catch (error) {
    console.error("Erreur sauvegarde planning:", error);
    showMessage("error", error.response?.data?.message || "Erreur serveur");
  } finally {
    setSaving(false);
  }
};



  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: "", text: "" }), 5000);
  };

  const getAvailableFamilies = () => {
    return familiesData
      .filter(family => family && family.name)
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  const availableFamilies = getAvailableFamilies();

  // Écran de chargement pendant le chargement des familles
  if (familiesLoading || locationsLoading) {
    return (
      <div className="inventory-admin-container loading">
        <div className="loading-spinner"></div>
        <p>Chargement des familles et localisations...</p>
      </div>
    );
  }

  // Écran si pas de familles
  if (availableFamilies.length === 0) {
    return (
      <div className="inventory-admin-container">
        <div className="admin-header">
          <h1>⚙️ Administration des Inventaires</h1>
          <p>Programmation des ingrédients à inventorier</p>
        </div>
        
        <div className="error-state">
          <div className="error-icon">⚠️</div>
          <h3>Aucune famille disponible</h3>
          <p>
            Il n'y a pas de familles d'ingrédients dans le système.
            <br />
            Veuillez d'abord créer des familles et y ajouter des ingrédients.
          </p>
          <button
            className="refresh-btn"
            onClick={loadFamiliesData}
            style={{ marginTop: '20px' }}
          >
            🔄 Recharger les données
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="inventory-admin-container">
      <div className="admin-header">
        <h1>⚙️ Administration des Inventaires</h1>
        <p>Programmation des ingrédients à inventorier {locations.length > 0 && "par localisation"}</p>
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="admin-content">
        <div className="admin-section">
          <h2>1. Ajouter un ingrédient au planning</h2>
          
          <div className="admin-form">
            <div className="form-row">
              <div className="form-group">
                <label>Famille *</label>
                <select
                  name="family"
                  value={scheduleData.family}
                  onChange={handleInputChange}
                >
                  <option value="">Sélectionner une famille</option>
                  {availableFamilies.map(family => {
                    // Compter les ingrédients
                    let ingredientCount = 0;
                    if (family.ingredients && Array.isArray(family.ingredients)) {
                      ingredientCount = family.ingredients.length;
                    }
                    
                    return (
                      <option key={family._id} value={family._id}>
                        {family.name} ({ingredientCount} ingrédients)
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* AJOUT: Sélecteur de localisation */}
              <div className="form-group">
                <label>Localisation (optionnel)</label>
                <select
                  name="location"
                  value={scheduleData.location}
                  onChange={handleInputChange}
                >
                  <option value="">Toutes les localisations</option>
                  {locations.map(location => (
                    <option key={location._id} value={location._id}>
                      {location.name}
                    </option>
                  ))}
                </select>
                {locations.length === 0 && (
                  <div className="form-hint">
                    Aucune localisation configurée
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Ingrédient *</label>
                <select
                  name="ingredient"
                  value={scheduleData.ingredient}
                  onChange={handleInputChange}
                  disabled={!scheduleData.family}
                >
                  <option value="">Sélectionner un ingrédient</option>
                  {filteredIngredients.map(ingredient => (
                    <option key={ingredient.id} value={ingredient.id}>
                      {ingredient.name}
                      {ingredient.unit && ` (${ingredient.unit})`}
                      {ingredient.isScheduled && " ✓ Déjà programmé"}
                    </option>
                  ))}
                </select>
                {scheduleData.family && filteredIngredients.length === 0 && (
                  <div className="form-hint">
                    Aucun ingrédient disponible dans cette famille
                    {scheduleData.location && " pour cette localisation"}
                  </div>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Fréquence d'inventaire *</label>
                <select
                  name="frequency"
                  value={scheduleData.frequency}
                  onChange={handleInputChange}
                >
                  <option value="daily">Quotidien</option>
                  <option value="weekly">Hebdomadaire</option>
                  <option value="biweekly">Bimensuel</option>
                  <option value="monthly">Mensuel</option>
                  <option value="quarterly">Trimestriel</option>
                </select>
              </div>

              <div className="form-group">
                <label>Date de début</label>
                <input
                  type="date"
                  name="startDate"
                  value={scheduleData.startDate}
                  onChange={handleInputChange}
                  min={getTodayDate()}
                />
              </div>
            </div>

            <button
              className="add-schedule-btn"
              onClick={addToSchedule}
              disabled={!scheduleData.family || !scheduleData.ingredient}
            >
              ➕ Ajouter au planning
            </button>
          </div>
        </div>

        <div className="admin-section">
          <div className="section-header">
            <h2>2. Planning des inventaires ({scheduledItems.length} ingrédients)</h2>
            <div className="section-actions">
              <button
                className="refresh-btn"
                onClick={fetchScheduledItems}
                title="Actualiser le planning"
                style={{ marginRight: '10px' }}
              >
                🔄 Actualiser
              </button>
              <button
                className="save-schedule-btn"
                onClick={saveSchedule}
                disabled={saving || scheduledItems.length === 0}
              >
                {saving ? 'Enregistrement...' : '💾 Enregistrer le planning'}
              </button>
            </div>
          </div>

          {scheduledItems.length > 0 ? (
            <div className="schedule-table-container">
              <table className="schedule-table">
                <thead>
                  <tr>
                    <th>Ingrédient</th>
                    <th>Famille</th>
                    <th>Localisation</th> {/* AJOUTÉ */}
                    <th>Fréquence</th>
                    <th>Date de début</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {scheduledItems.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="ingredient-info">
                          <strong>{item.ingredientName}</strong>
                          <div className="ingredient-id">ID: {item.ingredient?.slice(-8) || 'N/A'}</div>
                          {item.unit && <div className="ingredient-unit">{item.unit}</div>}
                        </div>
                      </td>
                      <td>{item.familyName}</td>
                      <td>{item.locationName || 'Toutes'}</td> {/* AJOUTÉ */}
                      <td>
                        <select
                          value={item.frequency}
                          onChange={(e) => updateScheduleItem(item.ingredient, item.location, { 
                            frequency: e.target.value 
                          })}
                          className="frequency-select"
                        >
                          <option value="daily">Quotidien</option>
                          <option value="weekly">Hebdomadaire</option>
                          <option value="biweekly">Bimensuel</option>
                          <option value="monthly">Mensuel</option>
                          <option value="quarterly">Trimestriel</option>
                        </select>
                      </td>
                      <td>{item.startDate}</td>
                      <td>
                        <select
                          value={item.active ? 'active' : 'inactive'}
                          onChange={(e) => updateScheduleItem(item.ingredient, item.location, { 
                            active: e.target.value === 'active' 
                          })}
                          className="status-select"
                        >
                          <option value="active">Actif</option>
                          <option value="inactive">Inactif</option>
                        </select>
                      </td>
                      <td>
                        <button
                          className="remove-schedule-btn"
                          onClick={() => removeFromSchedule(item.ingredient, item.location)}
                          title="Retirer du planning"
                        >
                          ❌ Retirer
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-schedule">
              <div className="empty-icon">📅</div>
              <h4>Aucun ingrédient programmé</h4>
              <p>Commencez par ajouter des ingrédients au planning en utilisant le formulaire ci-dessus.</p>
            </div>
          )}
        </div>
      </div>

      <div className="info-panel">
        <div className="info-card">
          <h4>📊 Informations système</h4>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-label">Familles disponibles:</span>
              <span className="stat-value">{availableFamilies.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Localisations:</span>
              <span className="stat-value">{locations.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Ingrédients filtrés:</span>
              <span className="stat-value">{filteredIngredients.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Programmés:</span>
              <span className="stat-value">{scheduledItems.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Date du jour:</span>
              <span className="stat-value">{getTodayDate()}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="instructions">
        <h4>📋 Instructions d'administration</h4>
        <ol>
          <li>Sélectionnez une famille d'ingrédients</li>
          <li>Optionnel: Choisissez une localisation spécifique</li>
          <li>Choisissez un ingrédient dans la liste</li>
          <li>Sélectionnez la fréquence d'inventaire</li>
          <li>Cliquez sur "Ajouter au planning"</li>
          <li>Répétez pour tous les ingrédients à inventorier</li>
          <li>Modifiez les fréquences ou statuts si nécessaire</li>
          <li>Cliquez sur "Enregistrer le planning" pour sauvegarder</li>
        </ol>
        <div className="notes">
          <p><strong>Note :</strong> Les ingrédients programmés apparaîtront automatiquement dans l'inventaire journalier.</p>
          <p><strong>Localisation :</strong> Vous pouvez spécifier une localisation pour restreindre l'inventaire à un emplacement spécifique.</p>
        </div>
      </div>
    </div>
  );
};

export default DailyInventoryAdmin;